import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-status" }
const _hoisted_2 = { style: {"display":"flex"} }

import { ref, withDefaults } from 'vue';
import { BaseForm, BaseFormItem, BaseInput, BaseImage } from 'xrk-components';
import { allianceUserRnv } from '../data-source/apis';
// 声明 prop 属性

export default /*#__PURE__*/_defineComponent({
  __name: 'auth-status',
  props: {
    userId: { default: null }
  },
  setup(__props: any) {

const props = __props;

const formData = ref({
  name: '',
  phone: '',
  cardId: '',
  cardIdFront: '',
  cardIdBack: '',
  bankCardNum: '',
  bankInfo: ''
});

const getInfo = async () => {
  const { data } = await allianceUserRnv({
    userId: props.userId
  });
  formData.value = data;
};
getInfo();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseForm), { "label-position": "right" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_unref(BaseFormItem), {
              prop: "",
              label: "终端服务人员"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  disabled: "",
                  "model-value": formData.value.name
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(BaseFormItem), {
              prop: "",
              label: "手机号"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  disabled: "",
                  "model-value": formData.value.phone
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_unref(BaseFormItem), {
          prop: "",
          label: "身份证号"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              disabled: "",
              "model-value": formData.value.cardId
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "",
          label: "身份证照片"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseImage), {
              style: {"width":"180px","height":"100px","margin-right":"40px"},
              src: formData.value.cardIdFront,
              "preview-src-list": [formData.value.cardIdFront]
            }, null, 8, ["src", "preview-src-list"]),
            _createVNode(_unref(BaseImage), {
              style: {"width":"180px","height":"100px"},
              src: formData.value.cardIdBack,
              "preview-src-list": [formData.value.cardIdBack]
            }, null, 8, ["src", "preview-src-list"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "",
          label: "银行卡号"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              disabled: "",
              "model-value": formData.value.bankCardNum
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          prop: "",
          label: "银行名称"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              disabled: "",
              "model-value": formData.value.bankInfo
            }, null, 8, ["model-value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})